<template>
  <section class="packages-status">
    <div class="packages-status__header">
      <p class="packages-status__intro mb-0">
        Hier sehen Sie den aktuellen Paketstatus Ihrer ausgewählten Organisation und mögliche Erweiterungen.
      </p>
      <div class="packages-status__count">
        <strong>{{ totalActiveCount }}</strong>
        <span>aktive Pakete</span>
      </div>
    </div>

    <div class="packages-status-grid">
      <PackageStatusCard
        v-for="row in primaryRows"
        :key="`status-${row.key}`"
        :row="row"
        :reactivating-ids="reactivatingIds"
        :route-query="routeQuery"
        @continue-recurring="$emit('continue-recurring', $event)"
        @scroll-to-row="$emit('scroll-to-row', $event)"
      />
    </div>

    <div v-if="secondaryRows.length" class="packages-status-secondary">
      <div class="packages-status-secondary__copy">
        <span>Weitere Paket-Typen</span>
        <p class="mb-0">Nicht aktiv, aber weiterhin verfügbar.</p>
      </div>
      <div class="packages-status-secondary__items">
        <button
          v-for="row in secondaryRows"
          :key="`secondary-status-${row.key}`"
          type="button"
          class="packages-status-secondary__item"
          :class="getBaseTypeThemeClass(row.key)"
          :style="getBaseTypeThemeStyle(row.key)"
          @click="$emit('scroll-to-row', row.key)"
        >
          <span>
            <strong>{{ row.label }}</strong>
            <br>
            <small>Kein Paket aktiv</small>
          </span>
          <Icon icon="fa-solid:plus" />
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import PackageStatusCard from '@/components/packages/PackageStatusCard.vue'
import {getBaseTypeThemeClass, getBaseTypeThemeStyle} from '@/utils/baseTypeTheme'
import {useBootstrapPopovers} from '@/composables/useBootstrapPopovers'

export default {
  name: 'PackagesStatusOverview',
  components: {PackageStatusCard},
  emits: ['continue-recurring', 'scroll-to-row'],
  props: {
    primaryRows: {type: Array, required: true},
    secondaryRows: {type: Array, default: () => []},
    totalActiveCount: {type: Number, default: 0},
    reactivatingIds: {type: Array, default: () => []},
    routeQuery: {type: Object, default: () => ({})},
  },
  setup() {
    useBootstrapPopovers()
  },
  methods: {
    getBaseTypeThemeClass,
    getBaseTypeThemeStyle,
  },
}
</script>

<style scoped lang="scss">
.packages-status {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  border: 1px solid #d8e1ea;
  background: #ffffff;
}

.packages-status__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
}

.packages-status__intro {
  flex: 1 1 auto;
  color: #4e6477;
  max-width: 56ch;
}

.packages-status__count {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 11rem;
  padding: 1rem 1.25rem;
  border: 1px solid #d8e1ea;
  background: #f7fafc;
}

.packages-status__count strong {
  font-size: 2rem;
  line-height: 1;
  color: #10273d;
}

.packages-status__count span {
  color: #5d7183;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-size: 0.74rem;
}

.packages-status-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 22rem), 1fr));
  gap: 1rem;
}

.packages-status-secondary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem 1rem;
  border: 1px solid #e3e9f0;
  background: #f8fafc;
}

.packages-status-secondary__copy span {
  color: #10273d;
  font-weight: 700;
}

.packages-status-secondary__items {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
}

.packages-status-secondary__item {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.2rem;
  min-height: 3rem;
  padding: 0.55rem 0.75rem;
  border: 1px solid var(--base-type-border, #d8e1ea);
  border-left: 0.3rem solid var(--base-type-primary, #d8e1ea);
  background: #ffffff;
  color: var(--base-type-text, #10273d);
  text-align: left;
}

@media (max-width: 767px) {
  .packages-status__header {
    flex-direction: column;
  }
}
</style>
